import {
    DASHBOARD_EXPORT,
    DASHBOARD_EXPORT_SUCCESS,
    DASHBOARD_EXPORT_FAILURE,
    RESET_DASHBOARD_EXPORT,
} from '../actions';

const initialState = {
    data: null,
    loadingDashboardExport: false,
    error: null,
};

const dashboardExportReducer = (state = initialState, action) => {
    switch (action.type) {
        case DASHBOARD_EXPORT: {            
            return {
                ...state,
                loadingDashboardExport: true,
                error: null,
            };
        }
        case DASHBOARD_EXPORT_SUCCESS: {                        
            return {
                ...state,
                loadingDashboardExport: false,
                data: action.payload,
                error: null,
            };
        }
        case DASHBOARD_EXPORT_FAILURE: {
            const { error } = action.payload || {};
            return {
                ...state,
                loadingDashboardExport: false,
                data: null,
                error,
            };
        }
        case RESET_DASHBOARD_EXPORT:
            return initialState;
        default:
            return state;
    }
};

export default dashboardExportReducer;